/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import styled from 'styled-components';
import Config from 'Config';

const StyledRequirementStatus = styled.div<{
    met: boolean;
    fontSize: string;
    fontWeight: number | string;
}>`
    font-size: ${({ fontSize }) => fontSize};
    font-weight: ${({ fontWeight }) => fontWeight};
    color: ${({ met }) => (met ? Config.color.green : Config.color.red)};
`;
interface RequirementStatusProps {
    total?: number;
    unmet?: number;
    fontSize?: string;
    fontWeight?: number | string;
}
export const RequirementStatus = ({
    total = 0,
    unmet = 0,
    fontSize = 'inherit',
    fontWeight = 'inherit',
}: RequirementStatusProps) => {
    const allMet = unmet === 0;

    return (
        <StyledRequirementStatus
            met={allMet}
            fontSize={fontSize}
            fontWeight={fontWeight}
        >
            {allMet ? 'All completed' : `${unmet} out of ${total} not met`}
        </StyledRequirementStatus>
    );
};
